export default [
    {
        path: "/xhs/model/list",
        name: "xhs-model-list",
        component: () => import("@/views/xhs/model/list.vue"),
    },
    {
        path: "/xhs/model/view",
        name: "xhs-model-view",
        component: () => import("@/views/xhs/model/view.vue"),
    },
    {
        path: "/xhs/model/dataset/list",
        name: "xhs-model-dataset-list",
        component: () => import("@/views/xhs/model/dataset/list.vue"),
    },
    {
        path: "/xhs/model/dataset/view",
        name: "xhs-model-dataset-view",
        component: () => import("@/views/xhs/model/dataset/view.vue"),
    },
    {
        path: "/xhs/account/list",
        name: "xhs-account-list",
        component: () => import("@/views/xhs/account/list.vue"),
    },
    {
        path: "/xhs/account/view",
        name: "xhs-account-view",
        component: () => import("@/views/xhs/account/view.vue"),
    },

    {
        path: "/xhs/launch/list",
        name: "xhs-launch-list",
        component: () => import("@/views/xhs/launch/list.vue"),
    },
    {
        path: "/xhs/launch/new",
        name: "xhs-launch-new",
        component: () => import("@/views/xhs/launch/new.vue"),
    },

    {
        path: "/xhs/partner/sub/list",
        name: "xhs-partner-sub-list",
        component: () => import("@/views/xhs/partner/sub/list.vue"),
    },
]